/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection07FoiChanged, m11ReportSection07ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection07Foi, selectM11ReportSection07Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveDiscontinuationChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section07State, setAlertModalState, setStartingSection07State) => {

    let changesStates = {
        section07State: section07State
    };
    let response = await saveM11Changes(apiToken, 26, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection07Resource) {
            dispatch(m11ReportSection07ResourceChanged(response.m11ReportSection07Resource));
        }
        setStartingSection07State(JSON.parse(JSON.stringify(section07State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step026ParticipantDiscontinuation = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection07Foi = useSelector(selectM11ReportSection07Foi);
    const m11ReportSection07Resource = useSelector(selectM11ReportSection07Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section07State, setSection07State] = useState({
        "section72Status": "empty", "section72Xhtml": "",
        "section711Status": "empty", "section711Xhtml": "",
        "section712Status": "empty", "section712Xhtml": "",
        "section713Status": "empty", "section713Xhtml": "",
        "section73Status": "empty", "section73Xhtml": ""
    });
    const [startingSection07State, setStartingSection07State] = useState({
        "section72Status": "empty", "section72Xhtml": "",
        "section711Status": "empty", "section711Xhtml": "",
        "section712Status": "empty", "section712Xhtml": "",
        "section713Status": "empty", "section713Xhtml": "",
        "section73Status": "empty", "section73Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section07State, startingSection07State)),
        async saveAllChanges() {
            await saveDiscontinuationChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section07State, setAlertModalState, setStartingSection07State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section72Status": "empty", "section72Xhtml": "",
                "section711Status": "empty", "section711Xhtml": "",
                "section712Status": "empty", "section712Xhtml": "",
                "section713Status": "empty", "section713Xhtml": "",
                "section73Status": "empty", "section73Xhtml": "",
                "loaded": true
            };
            setSection07State(startingData);
            setStartingSection07State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[7]?.entry?.length) {
                let m11ReportSection007Foi = getIdFromReference(m11ReportContainerResource.section[7].entry[0]);
                if (m11ReportSection007Foi && !isNaN(m11ReportSection007Foi) && m11ReportSection007Foi !== m11ReportSection07Foi) {
                    dispatch(m11ReportSection07FoiChanged(m11ReportSection007Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection07Foi && !isNaN(m11ReportSection07Foi)) {
            loadResource(m11ReportSection07Foi, "M11ReportSection07", apiToken, dispatch);
        }
    }, [m11ReportSection07Foi]);

    useEffect(() => {
        if (m11ReportSection07Resource && Object.keys(m11ReportSection07Resource).length > 0) {
            let startingData = {
                "section72Status": "empty", "section72Xhtml": "",
                "section711Status": "empty", "section711Xhtml": "",
                "section712Status": "empty", "section712Xhtml": "",
                "section713Status": "empty", "section713Xhtml": "",
                "section73Status": "empty", "section73Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection07Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection07Resource.section[0].section[1]?.text?.div &&
                    m11ReportSection07Resource.section[0].section[1].text.status !== "empty") {
                    startingData.section72Status = m11ReportSection07Resource.section[0].section[1].text.status;
                    startingData.section72Xhtml = m11ReportSection07Resource.section[0].section[1].text.div;
                }
                if (m11ReportSection07Resource.section[0].section[0]?.section?.length > 0) {
                    if (m11ReportSection07Resource.section[0].section[0].section[0]?.text?.div &&
                        m11ReportSection07Resource.section[0].section[0].section[0].text.status !== "empty") {
                        startingData.section711Status = m11ReportSection07Resource.section[0].section[0].section[0].text.status;
                        startingData.section711Xhtml = m11ReportSection07Resource.section[0].section[0].section[0].text.div;
                    }
                    if (m11ReportSection07Resource.section[0].section[0].section?.[1]?.text?.div &&
                        m11ReportSection07Resource.section[0].section[0].section[1].text.status !== "empty") {
                        startingData.section712Status = m11ReportSection07Resource.section[0].section[0].section[1].text.status;
                        startingData.section712Xhtml = m11ReportSection07Resource.section[0].section[0].section[1].text.div;
                    }
                    if (m11ReportSection07Resource.section[0].section[0].section?.[2]?.text?.div &&
                        m11ReportSection07Resource.section[0].section[0].section[2].text.status !== "empty") {
                        startingData.section713Status = m11ReportSection07Resource.section[0].section[0].section[2].text.status;
                        startingData.section713Xhtml = m11ReportSection07Resource.section[0].section[0].section[2].text.div;
                    }
                }
                if (m11ReportSection07Resource.section[0].section[2]?.text?.div &&
                    m11ReportSection07Resource.section[0].section[2].text.status !== "empty") {
                    startingData.section73Status = m11ReportSection07Resource.section[0].section[2].text.status;
                    startingData.section73Xhtml = m11ReportSection07Resource.section[0].section[2].text.div;
                }
                setSection07State(startingData);
                setStartingSection07State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection07Resource]);

    return <div>
        <h3>Complete Section 7 Discontinuation</h3>
        {!(m11ReportSection07Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 26 (Complete Section 7 Discontinuation) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section07State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 7.1.1 Permanent Discontinuation of Trial Intervention as needed.</h4>
                    <TextDivEntry elementName="section711Xhtml"
                        startingValue={section07State.section711Xhtml}
                        setResourceState={setSection07State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 7.1.2 Temporary Discontinuation of Trial Intervention as needed.</h4>
                    <TextDivEntry elementName="section712Xhtml"
                        startingValue={section07State.section712Xhtml}
                        setResourceState={setSection07State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 7.1.3 Rechallenge as needed.</h4>
                    <TextDivEntry elementName="section713Xhtml"
                        startingValue={section07State.section713Xhtml}
                        setResourceState={setSection07State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 7.2 Participant Discontinuation or Withdrawal from the Trial summary as needed.</h4>
                    <TextDivEntry elementName="section72Xhtml"
                        startingValue={section07State.section72Xhtml}
                        setResourceState={setSection07State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 7.3 Management of Loss to Follow-Up summary as needed.</h4>
                    <TextDivEntry elementName="section73Xhtml"
                        startingValue={section07State.section73Xhtml}
                        setResourceState={setSection07State} />
                </>}
            </>
        }
    </div >
});

const M11Step026ParticipantDiscontinuationHelperText = <div>
    <h3>Complete Section 7 Discontinuation</h3>
    <div style={{ textAlign: "left" }}>
        <p>This section must align with the intercurrent events and their handling strategies introduced in Section 3 Trial Objectives and Associated Estimands, and with the investigational trial intervention described in Section 6 Trial Intervention and Concomitant Therapy.</p>
        <p>Enter data for Section 7.1.1 Permanent Discontinuation of Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the criteria for discontinuation of a participant from any trial intervention, carefully evaluating which are appropriate for the trial population and therapy being studied.</p>
            <p>Describe how participants who discontinue trial intervention will be followed after discontinuation. Depending on the chosen intercurrent event handling strategy, it will be important to continue to follow and ascertain outcomes in participants who discontinue trial intervention through the end of the trial to prevent missing data in important analyses. Refer to Section 1.3 Schedule of Activities for assessments to be performed at the time of and following discontinuation of trial intervention.</p>
            <p>Describe the process for collecting and recording the detailed reasons for discontinuing trial intervention if not described elsewhere.</p>
        </div>
        <p>Enter data for Section 7.1.2 Temporary Discontinuation of Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the criteria for temporary discontinuation or interruption of trial intervention for an individual participant.</p>
            <p>Describe what to do and which restrictions still apply if the participant has to temporarily discontinue or interrupt trial intervention.</p>
            <p>Describe which assessments will be performed for the stated duration of the trial.</p>
            <p>Details of any rechallenge or restart after temporary discontinuation of trial intervention due to a safety-related event should be included in Section 7.1.3 Rechallenge.</p>
        </div>
        <p>Enter data for Section 7.1.3 Rechallenge.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the criteria for rechallenge/restarting trial intervention, how and when to perform rechallenge, the number of rechallenges allowed during the trial, and whether all, or specify which, assessments will be performed for the stated duration of the trial.</p>
            <p>If rechallenge is not allowed, state this.</p>
        </div>
        <p>Enter data for Section 7.2 Participant Discontinuation or Withdrawal from the Trial.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the criteria for participant discontinuation or withdrawal from the trial.</p>
            <p>Describe the reason for withdrawal and the type of data to be collected for the final assessments with reference to the schedule of activities for the participant’s end of study visit unless provided in another section.</p>
            <p>In many cases, the only reason for a participant being considered withdrawn from the trial should be a participant’s withdrawal of consent to continue to participate in the trial. All other participants, including those who discontinue trial intervention, should remain in the trial and continue to be followed to prevent missing data in important analyses. Refer to Section 10 Statistical Considerations for the data that must be collected for the trial estimands.</p>
        </div>
        <p>Enter data for Section 7.3 Management of Loss to Follow-Up.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe how the trial will define how participants are lost to follow-up. In general, participants should be considered lost to follow-up only if they cannot be reached despite multiple attempts to contact them. Also describe approaches that will be used to minimise loss to follow-up, such as multiple, diverse methods to remain in contact with participants (e.g., telephone calls, texts, and emails to the participant) and how contacts will be recorded.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step026ParticipantDiscontinuationValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 26, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
        <h4>Step 26 (Complete Section 7 Discontinuation) {validationCheckState.step26numberOfChecks} issues checked. {validationCheckState.step26numberPassed} passed. {validationCheckState.step26numberFailed} failed.</h4>
        <p>Section 7 heading is 'PARTICIPANT DISCONTINUATION OF TRIAL INTERVENTION AND DISCONTINUATION OR WITHDRAWAL FROM TRIAL': {validationCheckState.resultCheckSection7Heading}</p>
        <p>Section 7 PARTICIPANT DISCONTINUATION OF TRIAL INTERVENTION AND DISCONTINUATION OR WITHDRAWAL FROM TRIAL does not have text: {validationCheckState.resultCheckSection7Text}</p>
        <p>Section 7.1 heading is 'Discontinuation of Trial Intervention for Individual Participants': {validationCheckState.resultCheckSection71Heading}</p>
        <p>Section 7.1 Discontinuation of Trial Intervention for Individual Participants does not have text: {validationCheckState.resultCheckSection71Text}</p>
        <p>Section 7.1.1 heading is 'Permanent Discontinuation of Trial Intervention': {validationCheckState.resultCheckSection711Heading}</p>
        <p>Section 7.1.1 Permanent Discontinuation of Trial Intervention has content: {validationCheckState.resultCheckSection711Content}</p>
        <p>Section 7.1.2 heading is 'Temporary Discontinuation of Trial Intervention': {validationCheckState.resultCheckSection712Heading}</p>
        <p>Section 7.1.2 Temporary Discontinuation of Trial Intervention has content: {validationCheckState.resultCheckSection712Content}</p>
        <p>Section 7.1.3 heading is 'Rechallenge': {validationCheckState.resultCheckSection713Heading}</p>
        <p>Section 7.1.3 Rechallenge has content: {validationCheckState.resultCheckSection713Content}</p>
        <p>Section 7.2 heading is 'Participant Discontinuation or Withdrawal from the Trial': {validationCheckState.resultCheckSection72Heading}</p>
        <p>Section 7.2 Participant Discontinuation or Withdrawal from the Trial has content: {validationCheckState.resultCheckSection72Content}</p>
        <p>Section 7.3 heading is 'Management of Loss to Follow-Up': {validationCheckState.resultCheckSection73Heading}</p>
        <p>Section 7.3 Management of Loss to Follow-Up has content: {validationCheckState.resultCheckSection73Content}</p>
    </div>}  </div>
}

export default M11Step026ParticipantDiscontinuation;
export { M11Step026ParticipantDiscontinuationHelperText, M11Step026ParticipantDiscontinuationValidationCheck };